import {
  CLEAR_AMENITIES,
  GET_ALLOWED_HOURS_SUCCESS,
  GET_AMENITIES_SUCCESS,
  GET_AMENITY_RESERVATIONS_SUCCESS,
  GET_AMENITY_RESERVATION_SUCCESS,
  GET_AMENITY_SUCCESS,
  GET_DOORS_AMENITY_SUCCESS,
  GET_RESERVED_DATES_SUCCESS,
  SET_AMENITY_RESERVATIONS_PLACEHOLDER,
} from '../actionConstants';

const defaultState = {
  amenityReservations: null,
  amenities: null,
  details: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_AMENITY_RESERVATIONS_PLACEHOLDER:
      return {
        ...state,
        amenityReservations: action?.placeholder,
      };
    case GET_AMENITY_RESERVATIONS_SUCCESS:
      return {
        ...state,
        amenityReservations: action?.res?.data,
      };
    case GET_AMENITY_RESERVATION_SUCCESS:
      return {
        ...state,
        amenityReservation: action?.res?.data,
      };
    case GET_AMENITIES_SUCCESS:
      return {
        ...state,
        amenities: action?.res?.data,
      };
    case GET_AMENITY_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          [action.amenityId]: {
            ...state.details?.[action.amenityId],
            data: action?.res?.data,
          },
        },
      };
    case GET_RESERVED_DATES_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          [action.amenityId]: {
            ...state.details?.[action.amenityId],
            reservedDates: action?.res?.data?.reservedDates,
            hasAvailableDates: action?.res?.data?.hasAvailableDates,
          },
        },
      };
    case GET_ALLOWED_HOURS_SUCCESS:
      return {
        ...state,
        details: {
          ...state.details,
          [action.amenityId]: {
            ...state.details?.[action.amenityId],
            allowedHours: action?.res?.data,
          },
        },
      };
    case GET_DOORS_AMENITY_SUCCESS:
      return {
        ...state,
        doorsToAssign: action?.res.data,
      };
    case CLEAR_AMENITIES:
      return defaultState;
    default:
      return state;
  }
};
